import { Text, useToast } from '@chakra-ui/react';
import React from 'react';
import { ConfirmationModal } from '../ConfirmationModal/ConfirmationModal';
import { localise } from '../../../services/lang/lang';
import useGenericMutationUseCase from '../../../hooks/usecases/generic/useGenericMutationUseCase';
import { useDeleteNote } from '../../../services/api/generated/client';
const DeleteNoteModal = ({ note, onClose, onDeleted }) => {
    const deleteNoteUseCase = useGenericMutationUseCase(useDeleteNote);
    const toast = useToast();
    const onDelete = () => {
        deleteNoteUseCase.execute({
            id: note.id,
        }, undefined, {
            onSuccess: () => {
                toast({
                    title: localise('NOTE_DELETED'),
                    status: 'success',
                    isClosable: true,
                    duration: 1000,
                });
                onDeleted();
            },
        });
    };
    return (React.createElement(ConfirmationModal, { isOpen: true, onClose: onClose, onConfirm: onDelete, title: localise('DELETE_NOTE'), isLoading: deleteNoteUseCase.isPending, isError: deleteNoteUseCase.isError, error: deleteNoteUseCase.error },
        React.createElement(Text, { "data-testid": "delete_note_modal__text", variant: "md-600-rg-3" }, localise('DELETE_NOTE_MODAL_MESSAGE'))));
};
export default DeleteNoteModal;
